export default class CloseCashier {
    constructor() {
        this.cashierId = "";
        this.userName = "";
        this.chartOfAccounts = { id: "", content: "" };
        this.bankAccount = { id: "", content: "" };
        this.movementList = [];
    }
}